module.exports = __webpack_public_path__ + "../resources/images/fileType_sprite-e417f6905e4721e21f515ea672c0433a.png";